import type Uppy from '@uppy/core';

export const hasErroredFiles = (uppy: Uppy) =>
  uppy.getFiles().some((file) => !!file.error);
